import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import { FaEye, FaPrint, FaTrash } from 'react-icons/fa';

const LEViewCertificate = () => {
    const navigate = useNavigate();
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const certsRef = ref(db, 'ekamwatapzp/GeneratedLECertificates');
        const unsubscribe = onValue(certsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                setCertificates(list);
            } else {
                setCertificates([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const filteredData = certificates.filter(cert =>
        cert.applicantName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cert.regNo?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8f9fa] flex flex-col  p-8">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 px-2">
                    <h1 className="text-xl font-medium text-gray-700">प्रमाणपत्र पहा</h1>
                    <div className="flex items-center text-sm font-medium text-gray-400 gap-2">
                        <span>जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-500 font-semibold">प्रमाणपत्र पहा</span>
                    </div>
                </div>

                {/* Main Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 max-w-[100%] overflow-hidden">

                    {/* Table Controls */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                        <div className="flex items-center rounded overflow-hidden shadow-sm border border-gray-300">
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Copy</button>
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Excel</button>
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium transition-colors">Print</button>
                        </div>

                        <div className="flex items-center gap-2">
                            <label className="text-sm font-medium text-gray-600">Search:</label>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                            />
                        </div>
                    </div>

                    {/* Data Table */}
                    <div className="overflow-x-auto border border-gray-200 rounded">
                        <table className="w-full text-left text-[13px] border-collapse bg-white">
                            <thead>
                                <tr className="bg-white border-b border-gray-200 font-bold divide-x divide-gray-100">
                                    <th className="px-3 py-4 w-12 text-center"># <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 min-w-[150px]">User Name <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4">Qualification <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4">Amount <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4">Registration class <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 min-w-[150px]">Certificate term <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 min-w-[150px]">Work Eligibility <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4">Registration No. <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 min-w-[200px]">Address <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 w-20 text-center">Action <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {loading ? (
                                    <tr><td colSpan="10" className="text-center py-10 text-gray-400 italic">Data Loading...</td></tr>
                                ) : filteredData.length > 0 ? (
                                    filteredData.map((cert, index) => (
                                        <tr key={cert.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'} hover:bg-gray-100/50 transition-colors divide-x divide-gray-100`}>
                                            <td className="px-3 py-4 text-center font-medium">{index + 1}</td>
                                            <td className="px-3 py-4 font-bold text-gray-800 tracking-tight">{cert.applicantName}</td>
                                            <td className="px-3 py-4">{cert.qualification}</td>
                                            <td className="px-3 py-4">{cert.amount}</td>
                                            <td className="px-3 py-4">{cert.regClass}</td>
                                            <td className="px-3 py-4">{cert.term}</td>
                                            <td className="px-3 py-4">{cert.eligibility}</td>
                                            <td className="px-3 py-4 font-medium">{cert.regNo}</td>
                                            <td className="px-3 py-4 text-gray-600 leading-snug">{cert.address}</td>
                                            <td className="px-3 py-4">
                                                <div className="flex items-center justify-center gap-3 text-gray-500">
                                                    <button className="hover:text-blue-500 transition-colors" title="पहा">
                                                        <FaEye size={16} />
                                                    </button>
                                                    <button className="hover:text-amber-500 transition-colors" title="प्रिंट">
                                                        <FaPrint size={15} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="px-6 py-12 text-center text-gray-500 font-medium">
                                            No data available in table
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Section */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mt-8 text-sm text-gray-600 font-medium">
                        <p>Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} entries</p>
                        <div className="flex shadow-sm rounded-md overflow-hidden border border-gray-300">
                            <button className="px-4 py-1.5 bg-white hover:bg-gray-50 border-r border-gray-300 transition-colors text-gray-500">Previous</button>
                            <button className="px-4 py-1.5 bg-indigo-600 text-white font-bold">{filteredData.length > 0 ? 1 : 0}</button>
                            <button className="px-4 py-1.5 bg-white hover:bg-gray-50 border-l border-gray-300 transition-colors text-gray-500">Next</button>
                        </div>
                    </div>

                </div>
            </div>
        </InchargeLayout>
    );
};

export default LEViewCertificate;
